import { makeCrewLoader } from '~/utils/routing';
import { isAddressPhoneRequired } from '~/utils/theme';

export const { loader, useLoaderData: useAddressData } = makeCrewLoader(
  ({ context }) => ({
    address: context.address ?? context.order.shippingAddress,
    requirePhone: isAddressPhoneRequired(
      context.settings.theme,
      context.lineItemClaims[0]?.claimType,
    ),
  }),
);
